// extracted by mini-css-extract-plugin
export var loadingSpinner = "_43-1";
export var standaloneTable = "_43-0";